module.exports = __webpack_public_path__ + "media/images/prequalified-banner-862f7c57.png";